import {Axios} from '../index'
import axios from "axios";
const _mod = '/admin/upload'
export default{
    uploadFiles(file){
        // return Axios.post(`${_mod}/files`,data)
      return new Promise((resolve, reject) => {
        // res.then((res) => res[0] ? reject(res[0]) : resolve(res[1]));
        let url = '/admin/upload/authUrl';
        console.log(file)
        Axios.get(url, { params: { filename: file.name } })
          .then(res => {
            if (res.status === 0) {
              const { uploadUrl,accessUrl } = res.data || {};
              if (!uploadUrl || !/^https?:\/\//i.test(uploadUrl)) {
                reject(new Error('上传地址无效: ' + uploadUrl));
                return;
              }
              console.log({ uploadUrl })
              axios({
                method: 'PUT',
                url: uploadUrl,
                headers: { 'Content-Type': file.type },
                data: file,
              }).then(response => {
                resolve({
                  status:0,
                  data:accessUrl
                })
              }).catch(err => reject(err));
            } else {
              reject(new Error(res && res.msg || '获取上传地址失败'));
            }
          }).catch(err => reject(err))
      });
    },
}



// WEBPACK FOOTER //
// ./src/api/src/upload.js